import React , {useEffect, useRef, useState} from 'react';
import withMultiverseApi from '../../hoc/multiverseApiProvider/withMultiverseApi';
import { MultiverseFile, WithMultiverseApiProps } from '../../hoc/multiverseApiProvider';
import AdminPage from '../../components/adminPage';
import { Accordion, Breadcrumb, Button, Card, Col, Container, Form, ListGroup, ListGroupItem, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

type AdminAgentsPageProps = {

} & WithMultiverseApiProps & RouteComponentProps;


function _AdminAgentsPage( props: AdminAgentsPageProps) {

  const [loading, setLoading] = useState<boolean>(false);
  const [updatingEmbeddings, setUpdatingEmbeddings] = useState<boolean>(false);

  const [forceUpdateDocs, setForceUpdateDocs] = useState<boolean>(false);
  const [forceUpdateEntities, setForceUpdateEntities] = useState<boolean>(false);
  const [forceUpdateDomainDocs, setForceUpdateDomainDocs] = useState<boolean>(false);
  const [entityFilter, setEntityFilter] = useState<string[]>([])

  const validEntityTypes = [
    "user",
    "domain",
    "location",
    "event",
    "plot",
    "landmark",
  ]


  const updateGoogleDocs = async () => {
    setUpdatingEmbeddings(true);
    try {
        let url = '/v2/admin/agents/embedding/process?collection=external_docs';
        if (forceUpdateDocs) {
            url += '&force_update=true';
        }
        const response = await props.multiverse.get<any>(url)
        alert(JSON.stringify(response));
    } catch (error) {
        console.error(error);
        alert("Error: " + JSON.stringify(error));
    }
    setUpdatingEmbeddings(false);
}

const updateDomainDocs = async () => {
  setUpdatingEmbeddings(true);
  try {
      let url = '/v2/admin/agents/embedding/process?collection=domain_docs';
      if (forceUpdateDomainDocs) {
          url += '&force_update=true';
      }
      const response = await props.multiverse.get<any>(url)
      alert(JSON.stringify(response));
  } catch (error) {
      console.error(error);
      alert("Error: " + JSON.stringify(error));
  }
  setUpdatingEmbeddings(false);
}

const updateEntities = async () => {
    setUpdatingEmbeddings(true);
    try {
        let url = '/v2/admin/agents/embedding/process?collection=entities';
        if (forceUpdateEntities) {
            url += '&force_update=true';
        }
        if (entityFilter.length > 0) {
            entityFilter.forEach((type) => {
                url += '&entity_types[]=' + type;
            })
        }
        const response = await props.multiverse.get<any>(url)
        alert(JSON.stringify(response));
    } catch (error) {
        console.error(error);
        alert("Error: " + JSON.stringify(error));
    }
    setUpdatingEmbeddings(false);
}


const UpdateEmbeddingsCard = () => {
  return (
    <Card>
      <Card.Header>
        <Card.Title>
          Update Embeddings
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group as={Row} controlId="docs" className="align-items-center">
            <Col sm="3">
            {!updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} onClick={updateGoogleDocs}>Process Updated GoogleDocs</Button>}
            {updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} disabled><Spinner animation="border" /></Button>}
            </Col>
            {// add a checbox to for a force_update option
            <Col sm="2">
            <Form.Check type="checkbox" label="Force Update All" id="force_update"
              checked={forceUpdateDocs}
              onChange={(e) => setForceUpdateDocs(e.currentTarget.checked)} />
            </Col> 
            }
          </Form.Group>
          <Form.Group as={Row} controlId="entities" className="align-items-top border-top pt-3 mt-3">
            <Col sm="3">
            {!updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} onClick={updateEntities}>Process Updated Entities</Button>}
            {updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} disabled><Spinner animation="border" /></Button>}
            </Col>
            {
              // add dropdown to select entity type(s) to update, if blank, update all
              <Col sm={2}>
                <Form.Group>
                  {validEntityTypes.map(type => (
                    <Form.Check
                      key={type}
                      type="checkbox"
                      id={`entity-${type}`}
                      label={type.charAt(0).toUpperCase() + type.slice(1)}
                      checked={entityFilter.includes(type)}
                      onChange={() =>
                        setEntityFilter(prev =>
                          prev.includes(type)
                            ? prev.filter(t => t !== type)
                            : [...prev, type]
                        )
                      }
                    />
                  ))}
                </Form.Group>
              </Col>
            }
            {// add a checbox to for a force_update option
            <Col sm="2">
            <Form.Check type="checkbox" label="Force Update All" id="force_update_entities"
              checked={forceUpdateEntities}
              onChange={(e) => setForceUpdateEntities(e.currentTarget.checked)} />
            </Col> 
            }
          </Form.Group>
          <Form.Group as={Row} controlId="domain_docs" className="align-items-center">
            <Col sm="3">
            {!updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} onClick={updateDomainDocs}>Process Domain Docs</Button>}
            {updatingEmbeddings && <Button variant="primary" style={{width:'100%'}} disabled><Spinner animation="border" /></Button>}
            </Col>
            {// add a checbox to for a force_update option
            <Col sm="2">
            <Form.Check type="checkbox" label="Force Update All" id="force_update_domain"
              checked={forceUpdateDomainDocs}
              onChange={(e) => setForceUpdateDomainDocs(e.currentTarget.checked)} />
            </Col> 
            }
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};




//   useEffect(() => {
//     props.multiverse.get<TGlobalConfig>("/v2/agents/globalconfig_costs").then((config) => {
//       setGlobalConfig(config);
//       setEditedGlobalConfig(config);
//       setLoading(false);
//     }).catch((err) => {
//       console.error(err);
//       setLoading(false);
//     })
//   }, []);



  return (
    <AdminPage>
      <h4><b><Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin/agents" }}>Agents</Breadcrumb.Item>
          <Breadcrumb.Item active><b>Manage Embeddings</b></Breadcrumb.Item>
      </Breadcrumb></b></h4>

      {!loading && (
        <UpdateEmbeddingsCard
        />
      )}

    </AdminPage>
  );
}
export const AdminAgentsEmbeddingsPage = withRouter(withMultiverseApi(_AdminAgentsPage));

export default AdminAgentsEmbeddingsPage;

